export default __webpack_public_path__ + "static/media/top-pahkla.08c57740.jpg";